import type {
  FormattedScores,
  SaveScoringRequest,
  SaveScoringResponse
} from '@library/types/scoring';
import type {
  GamePlayerProjectionsAndScoresRequest,
  ProjectionsAndScoresAPIResponse
} from '@library/types/projection';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { getGamePlayerProjectionScore } from '@bo-utils/scoring';

const { admin } = apiPaths;

export const scoringApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGamePlayerProjectionScore: build.query<
      FormattedScores | undefined,
      GamePlayerProjectionsAndScoresRequest
    >({
      query: ({
        createdByUserId,
        durationId,
        fromDate,
        gameId = undefined,
        gameModeIds = undefined,
        isOffTheBoard = undefined,
        leagueId,
        page = 1,
        perPage = 50,
        playerIds = undefined,
        reboot,
        search = undefined,
        sortBy = undefined,
        sortDirection = undefined,
        statTypeIds = undefined,
        status = undefined,
        team,
        toDate
      }) => ({
        url: `${admin}projections`,
        method: 'GET',
        params: {
          created_by_user_id: createdByUserId,
          duration_id: durationId,
          from_date: fromDate,
          game_ids: gameId,
          game_mode_ids: gameModeIds,
          is_off_the_board: isOffTheBoard,
          league_id: leagueId,
          new_player_ids: playerIds,
          page,
          per_page: perPage,
          search,
          stat_type_ids: statTypeIds,
          sort: sortBy && sortDirection ? `${sortBy}:${sortDirection}` : sortBy,
          statuses: status,
          teams: team,
          to_date: toDate,
          unders_win_dnp: reboot
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: ProjectionsAndScoresAPIResponse) =>
        getGamePlayerProjectionScore(response),
      providesTags: ['Scores']
    }),
    saveScoring: build.mutation<SaveScoringResponse, SaveScoringRequest>({
      query: (payload) => ({
        url: `${admin}scoring`,
        method: 'POST',
        body: payload,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data,
      invalidatesTags: ['Scores']
    })
  })
});

export const { useGetGamePlayerProjectionScoreQuery, useSaveScoringMutation } =
  scoringApi;
